import { getCookie } from './Cookies';

/**
 * This method will construct mbox url
 * @static
 * @memberof MboxHelper
 */
export const getMboxValuesFromCookie = () => {
    const mboxCookie = getCookie('mbox');
    if (mboxCookie) {
        const mboxValues = mboxCookie.split('|');
        const result = {
            session: '',
            PC: '',
        };
        mboxValues &&
            mboxValues.forEach((mboxValue) => {
                if (mboxValue.startsWith('session')) {
                    result.session = mboxValue.split('#')[1];
                }

                if (mboxValue.startsWith('PC')) {
                    result.PC = mboxValue.split('#')[1];
                }
            });
        return result;
    }
    return null;
};

/**
 * This method will construct mbox url
 * @static
 * @memberof MboxHelper
 */
export const constructUrlWithMboxParams = (input) => {
    const abtestUrl = input.url;
    const queryParams = [];
    const slotId = input && input.mbox;
    slotId && queryParams.push(`mbox=${slotId}`);
    const { hostname, href } = window.location;
    queryParams.push('mboxContentType=application/json');
    const mboxCookieValues = getMboxValuesFromCookie();
    if (mboxCookieValues) {
        if (mboxCookieValues.session) {
            queryParams.push(`mboxSession=${mboxCookieValues.session}`);
        }
        if (mboxCookieValues.PC) {
            queryParams.push(`mboxPC=${mboxCookieValues.PC}`);
        }
    }
    queryParams.push('mboxDefault=%7B%7D');
    queryParams.push('mboxXDomain=disabled');
    queryParams.push('mboxNoRedirect=true');
    queryParams.push(`mboxHost=${hostname}`);

    if (window.visitor) {
        const mcsdId = window.visitor.getSupplementalDataID();
        if (mcsdId) {
            queryParams.push(`mboxMCSDID=${mcsdId}`);
        }
    }

    queryParams.push(`mboxURL=${encodeURIComponent(href)}`);

    return `${abtestUrl}?${queryParams.join('&')}`;
};

export default class MboxHelper {
    static constructUrlWithMboxParams(input) {
        return constructUrlWithMboxParams(input);
    }

    static getMboxValuesFromCookie() {
        return getMboxValuesFromCookie();
    }
}
